import React from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  useLocation,
  Navigate,
} from "react-router-dom";

import Header from "./components/Header";
import Footer from "./components/Footer";
import ScrollToTop from "./components/ScrollToTop";

import Home from "./pages/Home";
import About from "./pages/About";
import Join from "./pages/Join";
import Hrcom from "./pages/Hrcom";
import Industry from "./pages/Industry";
import Branding from "./pages/Branding";
import TermsConditions from "./pages/Terms_Condition";
import Privacy from "./pages/Privacy";
import Refund from "./pages/Refund";
import Ourteam from "./pages/Ourteam";
import Ourpartner from "./pages/Ourpartner";
import Joinmodel from "./components/JoinModel";

import GetCertifiedPage from "./pages/Getcertifiedpage";

import Eventpage from "./pages/Eventpage";
import Attendees from "./pages/attendees";
import Eventform from "./components/Event_form";
import Dashboard from "./pages/dashboard";

import "./App.css";

// Routes that should NOT show Header/Footer
const NO_LAYOUT_ROUTES = ["/dashboard","/attendees"];

function AppContent() {
  const location = useLocation();
  const hideLayout = NO_LAYOUT_ROUTES.includes(location.pathname);

  return (
    <>
      <ScrollToTop />
      {!hideLayout && <Header />}

      <Routes>
        {/* Redirect localhost:3000 -> localhost:3000/home */}
        <Route path="/" element={<Navigate to="/home" replace />} />

        <Route path="/home" element={<Home />} />
        <Route path="/whatWeDo" element={<About />} />
        <Route path="/jointhecommunity" element={<Join />} />
        <Route path="/hrcommunity" element={<Hrcom />} />
        <Route path="/industryacademia" element={<Industry />} />
        <Route path="/employeebranding" element={<Branding />} />
        <Route path="/terms" element={<TermsConditions />} />
        <Route path="/privacy" element={<Privacy />} />
        <Route path="/refund" element={<Refund />} />
         <Route
  path="/getcertified"
  element={<GetCertifiedPage />}
/>
        <Route path="/ourteam" element={<Ourteam />} />
        <Route path="/ourpartner" element={<Ourpartner />} />
        <Route path="/joinmodel" element={<Joinmodel />} />
        <Route path="/events" element={<Eventpage />} />
        <Route path="/eventform" element={<Eventform />} />
        <Route path="/dashboard" element={<Dashboard />} />
        
        <Route path="/attendees" element={<Attendees />} />

        {/* Optional: Redirect unknown routes to Home */}
        <Route path="*" element={<Navigate to="/home" replace />} />
      </Routes>

      {!hideLayout && <Footer />}
    </>
  );
}

function App() {
  return (
    <Router>
      <AppContent />
    </Router>
  );
}

export default App;